module.exports = __webpack_public_path__ + "img/ResearchHUB Guiding Principles 11 06 2024-1.407e2c61.png";